import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Paragraph, Title } = Typography;

/**
 * Modal Android: um toque abre o diálogo nativo de instalação.
 */
const AndroidInstallModal = ({ open, onInstall, onDismiss, loading = false }) => (
  <Modal
    open={open}
    onCancel={onDismiss}
    footer={null}
    destroyOnClose
    centered
  >
    <Space direction="vertical" size={16} style={{ width: '100%', textAlign: 'center' }}>
      <DownloadOutlined style={{ fontSize: 40, color: '#B89040' }} />
      <Title level={4} style={{ margin: 0, color: '#1F4F4F' }}>
        Instale o Saldo Ativo
      </Title>
      <Paragraph type="secondary" style={{ margin: 0 }}>
        Adicione o app à tela inicial para abrir mais rápido, como um aplicativo.
      </Paragraph>
      <Button type="primary" size="large" block loading={loading} onClick={onInstall} icon={<DownloadOutlined />}>
        Instalar
      </Button>
      <Button type="link" onClick={onDismiss}>
        Agora não
      </Button>
    </Space>
  </Modal>
);

export default AndroidInstallModal;
